import { journeys } from "config/journeys"
import * as React from "react"
import Document from "components/Document"
import Footer from "components/Footer"
import JourneyCategoryPage from "components/start/JourneyCategoryPage"
import JourneyPageLink from "components/start/JourneyPageLink"
import Navbar from "components/Navbar"
import SideNav from "components/SideNav"
import PageWrapper, { PaddingTop } from "components/PageWrapper"
import imgPurchasingAHomeLandscape from "images/start/purchasing-a-home-landscape.jpg"

const StartRefinance: React.FC = () => {
  return (
    <Document
      title="Start your Refinance"
      description="Get a better rate, save on monthly payments, change the type or length of your loan, take cash out, or consolidate your debt."
      thumbnail={imgPurchasingAHomeLandscape}
      pageClass="bet-StaticPage"
      pageId="startPage"
      brandMetaPrefix={true}
    >
      <Navbar />
      <SideNav />
      <PageWrapper paddingTop={PaddingTop.Navbar}>
        <JourneyCategoryPage category={journeys.refinance}>
          <JourneyPageLink
            journey={journeys.refinance.pages["better-rate"]}
            urlPrefix="/start/"
            key="1"
            journeySlug="better-rate"
          />
          <JourneyPageLink
            journey={journeys.refinance.pages["getting-cash-out"]}
            urlPrefix="/start/"
            key="2"
            journeySlug="getting-cash-out"
          />
          <JourneyPageLink
            journey={journeys.refinance.pages["consolidating-debt"]}
            urlPrefix="/start/"
            key="3"
            journeySlug="consolidating-debt"
          />
        </JourneyCategoryPage>
        <Footer />
      </PageWrapper>
    </Document>
  )
}

export default StartRefinance
